import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@bi-studio/shared/hooks";
import { AppLayout } from "@bi-studio/shared/components";
import { RootFolderView, FolderTree } from "@/components/folders";

import { AiAssistant } from "@/components/ai";

export default function FoldersPage() {
    const { isAuthenticated, isLoading } = useAuth();
    const navigate = useNavigate();

    const handleLogout = React.useCallback(() => {
        navigate("/login");
    }, [navigate]);

    React.useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            navigate("/login");
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (!isLoading && !isAuthenticated) {
        return null;
    }

    const sidebarContent = <FolderTree />;

    return (
        <AppLayout
            showSidebar
            sidebarContent={sidebarContent}
            onLogout={handleLogout}
            floatingContent={<AiAssistant />}
        >
            <RootFolderView />
        </AppLayout>
    );
}
